// import React from "react";
// import EventsListPage from "./EventsListPage";

// const PastEvents = ({ events, title }) => {
//   return (
//     <div>
//       <EventsListPage events={events} title={title} />
//     </div>
//   );
// };

// export default PastEvents;

import React, { useEffect, useRef } from "react";
import EventsListPage from "./EventsListPage";
import { Trophy, History, Archive, Sparkles } from "lucide-react";

const PastEvents = ({ events, title }) => {
  const eventRef = useRef(null);

  useEffect(() => {
    setTimeout(() => {
      if (eventRef.current) {
        eventRef.current.scrollIntoView({
          behavior: "smooth",
          block: "center",
        });
      }
    }, 1000);
  });

  return (
    <div className="min-h-screen bg-gradient-to-br from-amber-50 via-white to-orange-50">
      {/* Hero Section */}
      <div className="relative bg-gradient-to-r from-amber-900 via-orange-800 to-amber-800 text-white py-16 md:py-20 overflow-hidden">
        <div className="absolute inset-0">
          <div className="absolute -top-24 -right-24 w-96 h-96 bg-amber-600/20 rounded-full blur-3xl"></div>
          <div className="absolute -bottom-24 -left-24 w-96 h-96 bg-orange-600/20 rounded-full blur-3xl"></div>
        </div>

        <div className="relative max-w-7xl mx-auto px-4 md:px-8 text-center">
          <div className="inline-flex items-center justify-center mb-6">
            <div className="relative">
              <div className="absolute inset-0 bg-gradient-to-r from-amber-400 to-orange-400 rounded-full blur-lg opacity-50"></div>
              <div className="relative w-20 h-20 rounded-full bg-gradient-to-br from-amber-300/20 to-orange-300/20 backdrop-blur-sm border-2 border-amber-300/30 flex items-center justify-center shadow-2xl">
                <Trophy className="w-10 h-10 text-white" />
              </div>
            </div>
          </div>

          <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold mb-6">
            Event{" "}
            <span className="relative inline-block">
              <span className="relative z-10">Archive</span>
              {/* <span className="absolute bottom-2 left-0 w-full h-3 bg-gradient-to-r from-amber-400 to-orange-400 -rotate-1"></span> */}
            </span>
          </h1>

          <p className="text-xl text-amber-100 max-w-3xl mx-auto mb-8">
            Relive memorable tournaments, celebrations, and special moments from
            RGCC's history
          </p>

          <div className="flex flex-wrap items-center justify-center gap-6">
            <div className="flex items-center gap-2 text-amber-200">
              <History className="w-5 h-5" />
              <span>Historical Moments</span>
            </div>
            <div className="w-1 h-1 bg-amber-300 rounded-full"></div>
            <div className="flex items-center gap-2 text-amber-200">
              <Archive className="w-5 h-5" />
              <span>70+ Tournaments</span>
            </div>
            <div className="w-1 h-1 bg-amber-300 rounded-full"></div>
            <div className="flex items-center gap-2 text-amber-200">
              <Sparkles className="w-5 h-5" />
              <span>Championship Legacy</span>
            </div>
          </div>
        </div>
      </div>

      {/* Events List */}
      <div ref={eventRef}>
        <EventsListPage events={events} title={title} />
      </div>
    </div>
  );
};

export default PastEvents;
